import { types } from "../../actions"

export default function collectionFetchReducer(state, action) {
  switch (action.type) {
    case types.fetch:
      return state
    case types.fetchSuccess: {
      return {
        ...state,
        data: action.data,
        meta: action.meta,
        error: action.error,
      }
    }
    default:
      return state
  }
}
